import React from 'react'
import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import { useNavigate } from 'react-router-dom'

const NotAuthorised = ({
  header = 'Access Restricted',
  headerCaption = 'Permission Required',
  title = 'You are not authorised to view this page',
  message = "You don't currently have permission to access this content. If you think this is a mistake, please contact your administrator.",
  showHomeButton = true,
  showBackButton = true,
  ...props
}) => {
  const navigate = useNavigate()

  return (
    <Box
      sx={(theme) => ({
        minHeight: 'calc(100vh - 140px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 4,
        // backgroundColor: theme.palette.anBackground?.main || 'red',
      })}
    >
      <Paper
        elevation={0}
        sx={(theme) => ({
          width: '100%',
          maxWidth: 560,
          borderRadius: 4,
          overflow: 'hidden',
          // border: `1px solid ${theme.palette.divider}`,
          boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
          backgroundColor:
            theme.palette.anWhite?.main || theme.palette.background.paper,
        })}
      >
        <Box
          sx={(theme) => ({
            px: { xs: 3, sm: 4 },
            py: 3,
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.contrast.main} 100%)`,
            color: theme.palette.contrast.contrastText,
          })}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={(theme) => ({
                width: 56,
                height: 56,
                borderRadius: '16px',
                display: 'grid',
                placeItems: 'center',
                backgroundColor: 'rgba(255,255,255,0.12)',
                border: '1px solid rgba(255,255,255,0.14)',
              })}
            >
              <LockOutlinedIcon sx={{ fontSize: 30 }} />
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: 'primary.contrastText',
                }}
              >
                {header}
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 0.5, color: 'primary.contrastText' }}
              >
                {headerCaption}
              </Typography>
            </Box>
          </Stack>
        </Box>

        <Box sx={{ px: { xs: 3, sm: 4 }, py: 4 }}>
          {props.children ? (
            props.children
          ) : (
            <Stack>
              <Typography
                variant="h6"
                sx={(theme) => ({
                  color: theme.palette.text.primary,
                  fontWeight: 700,
                  mb: 1.5,
                })}
              >
                {title}
              </Typography>

              <Typography
                variant="body1"
                sx={(theme) => ({
                  color: theme.palette.text.secondary,
                  lineHeight: 1.7,
                  mb: 3,
                })}
              >
                {message}
              </Typography>

              <Box
                sx={(theme) => ({
                  mb: 3,
                  px: 2,
                  py: 1.5,
                  borderRadius: 2,
                  backgroundColor: theme.palette.anMuted?.main || '#F1F5F9',
                  border: `1px solid ${theme.palette.divider}`,
                })}
              >
                <Typography
                  variant="body2"
                  sx={(theme) => ({
                    color: theme.palette.text.secondary,
                  })}
                >
                  This page may be restricted by your role, subscription tier,
                  or organisation settings.
                </Typography>
              </Box>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
                {showBackButton && (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<ArrowBackRoundedIcon />}
                    onClick={() => navigate(-1)}
                    sx={{ minWidth: 150 }}
                  >
                    Go back
                  </Button>
                )}

                {showHomeButton && (
                  <Button
                    variant="outlined"
                    startIcon={<HomeRoundedIcon />}
                    onClick={() => navigate('/')}
                    sx={(theme) => ({
                      minWidth: 150,
                      borderColor: theme.palette.divider,
                      color: theme.palette.text.primary,
                      '&:hover': {
                        borderColor: theme.palette.primary.main,
                        backgroundColor:
                          theme.palette.anMuted?.main || '#F8FAFC',
                      },
                    })}
                  >
                    Go to home
                  </Button>
                )}
              </Stack>
            </Stack>
          )}
        </Box>
      </Paper>
    </Box>
  )
}

export default NotAuthorised
